/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {SignupStepUrlMapperService} from "./signup-step-url-mapper.service";
import {CompanyRegistrationResourceService} from "@well/resource-services";
import {map} from "rxjs";
import {SignupStepDto} from "@well/domain";
import {JsonApiResource} from "@irian-ro/abstract-resource";

@Injectable({providedIn: 'root'})
export class SignupStepService{

  constructor(private signupStepUrlMapperService: SignupStepUrlMapperService,
              private companyRegistrationResourceService: CompanyRegistrationResourceService) {
  }

  getLastlyDoneSignupStepByCurrentUser(){
    return this.companyRegistrationResourceService.getLastlyDoneSignupStepByCurrentUser();
  }

  getUrlToNextSignupStep(){
    return this.companyRegistrationResourceService.getLastlyDoneSignupStepByCurrentUser().pipe(
      map((res: JsonApiResource<SignupStepDto, any>) => res.data),
      map((signupStep: SignupStepDto) => this.signupStepUrlMapperService.getUrlToNextStep(signupStep))
    );
  }

}
